// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"fcc44929","319":"a37a51d3","530":"7bd088ee","589":"7bd088ee","745":"ebb78001"}[chunkId] + ".chunk.css";
};